import { createSlice } from "@reduxjs/toolkit";
import { getHospitalCaseCredits } from "@custom/rtk-apis/Setting/creditForCaseToCase/getHospitalCaseCredit";

const initialState = {
  status: "",
  result: [],
  creditValue: 0,
  creditSymbol: "",
  msg: "",
  loading: false,
  error: ""
};

const getHospitalCaseCreditsSlice = createSlice({
  name: "getHospitalCaseCreditsSlice",
  initialState,
  reducers: {
    clearGetHospitalCaseCreditsState: (state) => {
      state.status = '';
      state.result = [];
      state.creditValue = 0;
      state.creditSymbol = '';
      state.msg = '';
      state.loading = false;
      state.error = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHospitalCaseCredits.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHospitalCaseCredits.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.caseCredits;
        state.creditValue = payload.creditValue;
        state.creditSymbol = payload.creditSymbol;
        state.msg = payload.msg;
      })
      .addCase(getHospitalCaseCredits.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
        state.status = "FAILED";
      });
  }
});

export default getHospitalCaseCreditsSlice.reducer;
export const { clearGetHospitalCaseCreditsState } = getHospitalCaseCreditsSlice.actions;
